import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <div className="container">
          <h1>Terms and Conditions</h1>
          {/* <p>Last updated: April 25, 2026</p> */}
        </div>
      </div>

      <div className="container policy-content my-5">
        <p className="intro">
          These Terms and Conditions govern your use of the Thrive Holdings Limited website and services. By accessing or using our services, you agree to be bound by these terms.
        </p>

        <section>
          <h2>Use of Our Services</h2>
          <p>
            You agree to use our services only for lawful purposes and in accordance with these terms. You must not use our services in any way that could damage, disable, or impair our systems or networks.
          </p>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            All content on our website, including text, graphics, logos, images, and software, is owned by Thrive Holdings Limited or our licensors and is protected by copyright and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2>User Accounts</h2>
          <p>
            If you create an account on our website, you are responsible for maintaining the confidentiality of your account information and password. You agree to accept responsibility for all activities that occur under your account.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Thrive Holdings Limited shall not be liable for any indirect, incidental, special, or consequential damages arising out of your use of our services or any content accessed through our website.
          </p>
        </section>

        <section>
          <h2>Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for the content, accuracy, or practices of these external sites. Your use of third-party websites is at your own risk and subject to their terms and conditions.
          </p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>
          <p>
            We may update these Terms and Conditions from time to time without notice. We will notify you of material changes by posting the new terms on this page. Your continued use of our services constitutes your acceptance of the updated terms.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about these Terms and Conditions, please <a href="/contact">contact us</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;